import { useState, useEffect } from "react";
import { Card, Row, Col } from "antd";
import { Line, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { useLanguage } from "../../../../context/LanguageContext";
import dashboardContent from "../../../../utils/dashboardContent";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  ArcElement,
  Tooltip,
  Legend
);

const pieColors = ["#52c41a", "#fadb14", "#ff4d4f"];

const Trends = ({ chartMetrics }) => {
  const [metrics, setMetrics] = useState(null);
  const { language } = useLanguage();
  const text = dashboardContent[language].reports.analysis;

  useEffect(() => {
    if (chartMetrics) {
      console.log(
        "Neue Daten für Trends erhalten:",
        chartMetrics.metrics.feedbackTrends
      );
      setMetrics(chartMetrics.metrics);
    }
  }, [chartMetrics]);

  // 🛠️ Feedback-Trends korrekt umwandeln
  const trendData = metrics?.feedbackTrends
    ? {
        labels: metrics.feedbackTrends.map((entry) => entry.date), // Datum als Label
        datasets: [
          {
            label: "Feedbacks",
            data: metrics.feedbackTrends.map((entry) => entry.count), // Anzahl als Wert
            borderColor: "#1890ff",
            backgroundColor: "rgba(24, 144, 255, 0.2)",
            borderWidth: 2,
            tension: 0.4,
          },
        ],
      }
    : null;

  // 🛠️ Feedback-Verteilung sicherstellen
  const distributionData = metrics?.distribution || [0, 0, 0];

  const pieChartData = {
    labels: [
      text.positiveFeedback,
      text.neutralFeedback,
      text.negativeFeedback,
    ],
    datasets: [
      {
        data: distributionData,
        backgroundColor: pieColors,
      },
    ],
  };

  return (
    <div>
      <Row gutter={[16, 16]} className="mb-6">
        {/* Feedback-Trends (Liniendiagramm) */}
        <Col xs={24} md={16}>
          <Card
            title={text.titleFeedbackTrends}
            bordered={false}
            className="shadow-md"
          >
            {trendData ? (
              <Line data={trendData} options={{ responsive: true }} />
            ) : (
              <p>{text.loadingData}</p>
            )}
          </Card>
        </Col>

        {/* Feedback-Verteilung (Kuchendiagramm) */}
        <Col xs={24} md={8}>
          <Card
            title={text.titleFeedbackDistribution}
            bordered={false}
            className="shadow-md"
          >
            {pieChartData ? (
              <Pie data={pieChartData} options={{ responsive: true }} />
            ) : (
              <p>{text.loadingData}</p>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Trends;
